import React, { useEffect, useState } from "react";

import Box from "@material-ui/core/Box";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

import HomeIcon from "@material-ui/icons/Home";
import CityIcon from "@material-ui/icons/LocationCity";
import BuildingIcon from "@material-ui/icons/Domain";

export default function TypeFilter({ setFilters }) {
  /**
   * Handle type filtering
   */
  const [value, setValue] = useState(0);

  useEffect(() => {
    setFilters(filters => {
      const statusFilter = filters.filter(f => f.key === "status");
      const key = value === 1 ? "residential" : "commercial";
      return value === 0 ? statusFilter : [...statusFilter, {key, condition: 'eq', value: true}]
    });
    // eslint-disable-next-line
  }, [value]);

  /**
   * track event in GA
   */
  useEffect(() => {
    const intents = ["show_all", "show_residential", "show_commercial"];
    window.gtag("event", "filter_buildings", {
      event_category: "engagement",
      event_label: intents[value]
    });
  }, [value]);

  return (
    <Box
      width={{ xs: "100%", md: 380 }}
      boxShadow={{ xs: 2, md: 0 }}
      borderRadius={{ xs: 0, md: 10 }}
      overflow="hidden"
      zIndex={20}
      position="absolute"
      bottom={0}
      bgcolor="white"
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        showLabels
      >
        <BottomNavigationAction label="All" icon={<CityIcon />} />
        <BottomNavigationAction label="Residential" icon={<HomeIcon />} />
        <BottomNavigationAction label="Commercial" icon={<BuildingIcon />} />
      </BottomNavigation>
    </Box>
  );
}
